import useTransferableData from "hooks/brc20/useTransferableData"
import { useAppDispatch, useAppSelector } from "hooks/redux/hooks"
import { setCurInscription } from "hooks/redux/slices/coreInfoSlice"
import { Row } from "style/preset"
import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"

import { ReactComponent as BalanceSvg } from 'assets/svgs/balance.svg'
import BaseBtnCom from "components/BaseBtnCom"
import { useUnisatWallet } from "hooks/wallet/useUnisatWalletProvider"
import { useCallback, useEffect } from "react"
import { getStore } from "utils/store"
import { useOkxBitcoinWallet } from "hooks/wallet/useOkxBitcoinWalletProvider"
import MainBtnBrc20Com from "./MainBtnBrc20Com"

const InscriptionListCom = () => {
    const { curInscription, toToken, fromChain } = useAppSelector((state) => state.coreInfo)
    const { dataList, availableBalance } = useTransferableData()
    const dispatch = useAppDispatch()

    const { getProvider: getProviderByUnisat } = useUnisatWallet()
    const { getProvider: getProviderByOkx, address} = useOkxBitcoinWallet()

    const fnOpenWallet = useCallback(async () => {
       try {
            const walletName = getStore('chainge.curWallet')
            if(walletName === 'okx_bitcoin') {
                if(!address) return
                const provider = getProviderByOkx()
                await provider.inscribe({type: 51, from: address, tick: toToken.symbol})
            } else {
                const provider = getProviderByUnisat()
                await provider.inscribeTransfer()
            }
       } catch(error) {}
    }, [address, getProviderByOkx, getProviderByUnisat, toToken])

    useEffect(() => {
        dispatch(setCurInscription({}))
    }, [toToken, fromChain, dispatch])


    return <InscriptionListWrap>
        <DesTitleBoxWrap $mb="20px">
            <DesTitleWrap>Available inscriptions</DesTitleWrap>
            <Row $justifyContent="space-between" $mt="18px">
                <Row>
                    <BalanceSvgWrap></BalanceSvgWrap>
                    <StyledContainer $fontSize="12px" $lineHeight="14px" $fontWeight4 $roobertRegular $color="#767A7F" $ml="6px">Balance</StyledContainer>
                </Row>
                <StyledContainer $fontSize="12px" $lineHeight="14px" $fontWeight5 $color="#767A7F">{availableBalance} {toToken?.symbol}</StyledContainer>
            </Row>
        </DesTitleBoxWrap>
        
        {
            !!dataList.length && <>
                <ScrollBoxWrap>
                    {
                        dataList.map((item:any, index) => <ItemWrap onClick={() => dispatch(setCurInscription(item))} key={index} $active={curInscription?.inscriptionId === item.inscriptionId}>
                            <StyledContainer $fontSize="12px" $lineHeight="14px" $fontWeight5 $color="#767A7F">#{item.inscriptionNumber}</StyledContainer>
                            <AmountWrap>{item?.data?.amt} {item?.data?.tick}</AmountWrap>
                        </ItemWrap>) 
                    }
                </ScrollBoxWrap>
                <StyledContainer $height="60px"></StyledContainer>
                <MainBtnBrc20Com></MainBtnBrc20Com>
            </>
        }
        {
            !!!dataList.length && <>
                <ItemWrap>
                    <StyledContainer $fontSize="12px" $lineHeight="14px" $fontWeight5 $color="#767A7F">There are no inscriptions available to transfer. Please inscribe first</StyledContainer>
                </ItemWrap>
                <StyledContainer $height="30px"></StyledContainer>
                <BaseBtnCom type="5" title="Engrave now" onClick={fnOpenWallet}></BaseBtnCom>
            </>
        }

        
    </InscriptionListWrap>
}

const InscriptionListWrap = styled(StyledContainer)``

const DesTitleBoxWrap = styled(StyledContainer)`
    border-left: 1px dashed #B5B7BA;
    padding: 10px 20px
`

const DesTitleWrap = styled(StyledContainer)`
    font-size: 18px;
    line-height: 18px
    font-weight: 600;
    font-family: RoobertSemiBold;
`

const BalanceSvgWrap = styled(BalanceSvg)`
  width: 16px;
  height: 16px;
`

const ScrollBoxWrap = styled(StyledContainer)`
    height: 40vh;
    overflow: auto;
`

const ItemWrap = styled(Row)<{$active: boolean}>`
    justify-content: space-between;
    height: 50px;
    padding: 10px 20px;
    box-sizing: border-box;
    box-shadow: 0px 2px 2px -2px rgba(24, 39, 75, 0.06), 0px 1px 2px 0px rgba(24, 39, 75, 0.08);
    background-color: #fff;
    margin: 0 3px;
    border-radius: 9px;
    margin-bottom: 10px;
    cursor: pointer;

    &:hover {
        box-shadow: 0px 8px 24px -4px rgba(24, 39, 75, 0.08), 0px 6px 12px -6px rgba(24, 39, 75, 0.12);
    }

    ${
       ({ $active }) => $active ? css`
        box-shadow: 0px 8px 24px -4px rgba(24, 39, 75, 0.08), 0px 6px 12px -6px rgba(24, 39, 75, 0.12);
        ${AmountWrap} {
            color: #fff;
            background-color: #4D1DF7;
        }
       `: css`
       
       `
    }
`
const AmountWrap = styled(StyledContainer)`
    padding: 8px;
    font-size: 12px;
    font-weight: 600;
    line-height: 14px;
    font-family: RoobertSemiBold;
    background-color: #F6F5F4;
    border-radius: 12px;
`



export default InscriptionListCom